export default function SummaryCard({
  bgColor = "",
  icon,
  value,
  valueColor = "",
  suffix,
  label,
  subLabel,
  "data-testid": dataTestId = "summary-card",
}) {
  return (
    <div className={`p-4 rounded-lg shadow-appShadow ${bgColor}`} data-testid={dataTestId}>
      <div className="flex gap-4 items-center justify-between h-full">
        <div className="iconHolder flex size-12 sm:size-16">
          {icon}
        </div>

        <div className="flex flex-col gap-3 sm:gap-2">
          <div className="flex items-baseline justify-end gap-2">
            <div
              className={`text-[32px] font-semibold leading-7 tracking-[0.048px] ${valueColor}`}
              data-testid={`${dataTestId}-value`}
            >
              {value}
            </div>

            {suffix && (
              <div
                className={`text-base font-semibold leading-7 tracking-[0.048px] ${valueColor}`}
                data-testid={`${dataTestId}-suffix`}
              >
                {suffix}
              </div>
            )}
          </div>

          <p className="text-dark-grey text-sm lg:text-lg leading-5 lg:leading-7 text-right tracking-[0.027px] flex flex-col" data-testid={`${dataTestId}-label`}>
            {label}
            {subLabel && <span className="text-xs font-normal" data-testid={`${dataTestId}-sublabel`}>{subLabel}</span>}
          </p>
        </div>
      </div>
    </div>
  );
}